import { render, staticRenderFns } from "./trains-info.vue?vue&type=template&id=63c2ac51&scoped=true"
import script from "./trains-info.vue?vue&type=script&lang=js"
export * from "./trains-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2ac51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c2ac51')) {
      api.createRecord('63c2ac51', component.options)
    } else {
      api.reload('63c2ac51', component.options)
    }
    module.hot.accept("./trains-info.vue?vue&type=template&id=63c2ac51&scoped=true", function () {
      api.rerender('63c2ac51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/express/components/trains-info.vue"
export default component.exports